export const cmtsPermissions = {
  public: "PUBLIC",
  dashboard: {
    read: "DASHBOARD.READ",
    management: "DASHBOARD.READ",
    personal: "DASHBOARD.READ",
  },
  workspace: {
    read: "DASHBOARD.READ",
    tasks: "TASK.READ",
    notifications: "NOTIFICATION.READ",
    messages: "MESSAGE.READ",
  },
  complaints: {
    read: "COMPLAINT.READ",
    readAll: "COMPLAINT.READ",
    create: "COMPLAINT.CREATE",
    update: "COMPLAINT.UPDATE",
    delete: "COMPLAINT.CLOSE",
    workflowAction: "COMPLAINT.WORKFLOW",
    evidence: "EVIDENCE.READ",
  },
  rcaCapa: {
    rcaRead: "RCA.READ",
    capaRead: "CAPA.READ",
    verificationRead: "VERIFICATION.READ",
  },
  reports: {
    read: "REPORT.READ",
    view: "REPORT.READ",
    export: "REPORT.EXPORT",
  },
  auditSecurity: {
    auditRead: "AUDIT.READ",
    securityRead: "SECURITY.READ",
  },
  administration: {
    read: "PLATFORM_ADMIN.READ",
    manage: "PLATFORM_ADMIN.MANAGE",
    tenantsRead: "TENANT.READ",
    tenantsCreate: "TENANT.CREATE",
    tenantsUpdate: "TENANT.UPDATE",
    tenantsDeactivate: "TENANT.DEACTIVATE",
    organizationUnitsRead: "ORG_UNIT.READ",
    organizationUnitsCreate: "ORG_UNIT.CREATE",
    organizationUnitsUpdate: "ORG_UNIT.UPDATE",
    organizationUnitsDeactivate: "ORG_UNIT.DEACTIVATE",
    usersRead: "USER.READ",
    usersCreate: "USER.CREATE",
    usersUpdate: "USER.UPDATE",
    usersDeactivate: "USER.DEACTIVATE",
    usersAssignRole: "USER.ASSIGN_ROLE",
    usersAssignOrgScope: "USER.ASSIGN_ORG_SCOPE",
    rolesRead: "ROLE.READ",
    rolesCreate: "ROLE.CREATE",
    rolesUpdate: "ROLE.UPDATE",
    rolesDeactivate: "ROLE.DEACTIVATE",
    rolesAssignPermission: "ROLE.ASSIGN_PERMISSION",
    permissionsRead: "PERMISSION.READ",
    permissionsCreate: "PERMISSION.CREATE",
    permissionsUpdate: "PERMISSION.UPDATE",
    permissionsDeactivate: "PERMISSION.DEACTIVATE",
    masterData: "MASTER_DATA.READ",
  },
  masterData: {
    priority: {
      read: "MASTER_DATA.READ",
      create: "MASTER_DATA.CREATE",
      update: "MASTER_DATA.UPDATE",
      delete: "MASTER_DATA.DELETE",
      activate: "MASTER_DATA.ACTIVATE",
      deactivate: "MASTER_DATA.DEACTIVATE",
    },
    severity: {
      read: "MASTER_DATA.READ",
      create: "MASTER_DATA.CREATE",
      update: "MASTER_DATA.UPDATE",
      delete: "MASTER_DATA.DELETE",
      activate: "MASTER_DATA.ACTIVATE",
      deactivate: "MASTER_DATA.DEACTIVATE",
    },
  },
} as const;

export type CmtsConfiguredPermissionCode = string;

export function isPublicCmtsPermission(permission: string | null | undefined): boolean {
  return !permission || permission === cmtsPermissions.public;
}

export function hasCmtsPermissionCode(permissions: readonly string[] | undefined, permission: string | null | undefined): boolean {
  if (isPublicCmtsPermission(permission)) return true;
  return Boolean(permission && (permissions ?? []).includes(permission));
}

export * from "../core/auth/permissionBridge.js";
